var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bokeh"},_vm._l((_vm.currentLightsCount),function(n){return _c('div',{key:n,staticClass:"light"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }